import { useEffect, useState } from 'react'

/**
 * Hook to detect if the device supports touch interactions
 * Returns true if the device has touch capability
 */
export const useTouchDevice = (): boolean => {
  const [isTouchDevice, setIsTouchDevice] = useState(() => {
    if (typeof window === 'undefined') return false

    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      // @ts-ignore - msMaxTouchPoints is IE specific
      navigator.msMaxTouchPoints > 0
    )
  })

  useEffect(() => {
    const checkTouchDevice = () => {
      const hasTouch = (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        // @ts-ignore - msMaxTouchPoints is IE specific
        navigator.msMaxTouchPoints > 0
      )
      setIsTouchDevice(hasTouch)
    }

    // Re-check on window resize (for hybrid devices)
    window.addEventListener('resize', checkTouchDevice)
    return () => window.removeEventListener('resize', checkTouchDevice)
  }, [])

  return isTouchDevice
}
